import React, { useState } from 'react';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import styles from './AdminHeader2Create.module.css';
import { storage } from '../../../firebaseConfig';

const AdminHeader2Create = ({ onCreate }) => {
    const [titulo, setTitulo] = useState('');
    const [desktopFile, setDesktopFile] = useState(null);
    const [mobileFile, setMobileFile] = useState(null);
    const [desktopPreview, setDesktopPreview] = useState('');
    const [mobilePreview, setMobilePreview] = useState('');
    const [uploading, setUploading] = useState(false);

    const handleFileUpload = async (file, path) => {
        const storageRef = ref(storage, path);
        const uploadTask = uploadBytesResumable(storageRef, file);

        return new Promise((resolve, reject) => {
            uploadTask.on(
                'state_changed',
                null,
                (error) => reject(error),
                async () => {
                    const url = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(url);
                }
            );
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setUploading(true);

        try {
            let imagemDesktop = '';
            let imagemMobile = '';

            if (desktopFile) {
                imagemDesktop = await handleFileUpload(
                    desktopFile,
                    `banners/${titulo.replace(/\s+/g, '_')}_desktop.jpg`
                );
            }

            if (mobileFile) {
                imagemMobile = await handleFileUpload(
                    mobileFile,
                    `banners/${titulo.replace(/\s+/g, '_')}_mobile.jpg`
                );
            }

            await onCreate({
                titulo,
                imagemDesktop,
                imagemMobile,
            });

            resetForm();
        } catch (error) {
            console.error('Erro ao criar banner:', error);
        } finally {
            setUploading(false);
        }
    };

    const resetForm = () => {
        setTitulo('');
        setDesktopFile(null);
        setMobileFile(null);
        setDesktopPreview('');
        setMobilePreview('');
    };

    return (
        <form onSubmit={handleSubmit} className={styles.form}>
            <input
                type="text"
                placeholder="Título"
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                className={styles.input}
                required
            />
            <div className={styles.fileUpload}>
                <label>
                    Imagem Desktop:
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            setDesktopFile(file);
                            setDesktopPreview(URL.createObjectURL(file));
                        }}
                        required
                    />
                </label>
                {desktopPreview && <img src={desktopPreview} alt="Preview Desktop" className={styles.previewImage} />}
            </div>
            <div className={styles.fileUpload}>
                <label>
                    Imagem Mobile:
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            setMobileFile(file);
                            setMobilePreview(URL.createObjectURL(file));
                        }}
                        required
                    />
                </label>
                {mobilePreview && <img src={mobilePreview} alt="Preview Mobile" className={styles.previewImage} />}
            </div>
            <p>*Desktop: 1920x1080 ou maior.</p>
            <p>*Mobile: 768x1024.</p>
            {uploading ? (
                <p>Fazendo upload...</p>
            ) : (
                <button type="submit" className={styles.button}>Criar Banner</button>
            )}
        </form>
    );
};

export default AdminHeader2Create;
